module.exports = __webpack_public_path__ + "media/images/referrals/family-trustees-82a205fe35cf2c311f2d59092b509889.png";